import type { ModalInfoProps } from '@/components/ModalInfo';
import { ModalInfo } from '@/components';

export default function ProjectedAnnualRevenueModal({
  ...rest
}: Partial<ModalInfoProps>) {
  return (
    <ModalInfo title="What is Projected Annual Revenue?" {...rest}>
      The projected annual revenue is calculated based on the current value of
      the assets and current APY for the next 12 months.
    </ModalInfo>
  );
}
